import React from "react";
import { addArrayItem, removeArrayItem, updateArrayItem } from "../utils/profailUtils";

export default function BankAccountsSection({ editMode, draft, setDraft }) {
    const list = draft?.bankAccounts || [];
    const setBanks = (next) => setDraft((prev) => ({ ...prev, bankAccounts: next }));

    if (!editMode) {
        if (!list.length) return <div className="pv2-muted">Tiada maklumat bank.</div>;

        return (
            <div className="pv2-bank-list">
                {list.map((b, i) => (
                    <div key={i} className="pv2-bank-item">
                        <div className="pv2-bank-name">{b.bank || "-"}</div>
                        <div className="pv2-bank-acc">{b.account || "-"}</div>
                        {b.holder ? <div className="pv2-bank-holder">{b.holder}</div> : null}
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="pv2-bank-edit">
            {list.map((b, i) => (
                <div key={i} className="pv2-bank-row">
                    <input
                        className="input-field"
                        placeholder="Nama Bank (cth: Maybank)"
                        value={b.bank || ""}
                        onChange={(e) => setBanks(updateArrayItem(list, i, { bank: e.target.value }))}
                    />
                    <input
                        className="input-field"
                        placeholder="No Akaun"
                        value={b.account || ""}
                        onChange={(e) => setBanks(updateArrayItem(list, i, { account: e.target.value }))}
                    />
                    <input
                        className="input-field"
                        placeholder="Nama Pemegang Akaun"
                        value={b.holder || ""}
                        onChange={(e) => setBanks(updateArrayItem(list, i, { holder: e.target.value }))}
                    />
                    <button type="button" className="pv2-danger" onClick={() => setBanks(removeArrayItem(list, i))}>
                        Padam
                    </button>
                </div>
            ))}

            <button
                type="button"
                className="filter-button"
                onClick={() => setBanks(addArrayItem(list, { bank: "", account: "", holder: "" }))}
            >
                + Tambah Akaun Bank
            </button>
        </div>
    );
}
